import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingVariations(props) {

  const [variants, setVariants] = useState([{ sku: "" }]);
  const [color, setColor] = useState("");
  const [size, setSize] = useState("");

  const COLOR_OPTIONS = [
    "Black", "White", "Silver", "Grey", "Red", "Blue", "Navy", 
    "Green", "Yellow", "Pink", "Purple", "Orange", "Brown", "Gold", "Beige"
  ];

  const ALL_SIZES = [
    "4 × 6 in", "5 × 7 in", "6 × 8 in", "8 × 10 in", "10 × 12 in", 
    "12 × 16 in", "16 × 20 in", "18 × 24 in", "12 × 18 in", "16 × 24 in", 
    "20 × 30 in", "24 × 36 in", "32 in", "40 in", "43 in", "50 in", 
    "55 in", "65 in", "75 in", "8 × 8 in", "10 × 10 in", "12 × 12 in", 
    "16 × 16 in", "20 × 20 in", "12 × 10 × 4 in", "20 × 15 × 8 in"
  ];

  const handleChange = (index, field, value) => {

    const updatedVariants = [...variants];
    updatedVariants[index][field] = value;
    setVariants(updatedVariants);

  };

  const addVariant = () => {

    setVariants([
      ...variants,
      { sku: "", size: "", color: "" }
    ]);

  };

  const removeVariant = (index) => {

    const updatedVariants = variants.filter((_, i) => i !== index);
    setVariants(updatedVariants);

  };

  return (

    <Container>

      <Row>

        {/* Title */}

        <Col md={12} className="mt-2 mb-2">
          <h4>Step 6 : Product Variations</h4>
        </Col>


        {/* Variants Card */}

        <Col md={12}>

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={12}>
                <h5><b>Manage Variants</b></h5>
              </Col>
            </Row>


            {/* Table Header */}

            <Row className="mb-2 amazon-listing-labels">

              <Col md={3}>SKU  </Col>
              <Col md={3}>Size  </Col>
              <Col md={3}>Color  </Col>
              {/* <Col md={3}>Action </Col> */}

            </Row>


            {/* Variant Rows */}

            {variants.map((variant, index) => (

              <Row className="mb-2" key={index}>

                <Col md={3}>

                  <Input
                    type="text"
                    // value={variant.sku}
                    value="STAD22LS-FrGrn-10pk"
                    onChange={(e) =>
                      handleChange(index, "sku", e.target.value)
                    }
                  />

                </Col>

                <Col md={3}>
                  {/* <Input 
                    type="select" 
                    value={variant.size} 
                    onChange={(e) => handleChange(index, "size", e.target.value)}
                  >
                    <option value="">Select Size</option>
                    {ALL_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
                  </Input> */}
                  <Input
                    type="text"
                    // value={variant.sku}
                    value={"5 3/4\" H x 3 5/8\" D x 2 3/4\" B"}
                    onChange={(e) =>
                      handleChange(index, "size", e.target.value)
                    }
                  />
                </Col>

                <Col md={3}>
                  {/* <Input 
                    type="select" 
                    value={variant.color}
                    onChange={(e) => handleChange(index, "color", e.target.value)}
                  >
                    <option value="">Select Color</option>
                    {COLOR_OPTIONS.map(c => <option key={c} value={c}>{c}</option>)}
                  </Input> */}
                  <Input
                    type="text"
                    // value={variant.sku}
                    value="Color Changing Frost to Green"
                    onChange={(e) =>
                      handleChange(index, "color", e.target.value)
                    }
                  />
                </Col>

                {/* <Col md={3}>

                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => removeVariant(index)}
                  >
                    Delete
                  </button>

                </Col> */}

              </Row>

            ))}


            {/* Add Variant Button

            <Row className="mt-3">

              <Col md={12}>

                <button
                  className="btn btn-secondary"
                  onClick={addVariant}
                >
                  + Add Variant
                </button>

              </Col>

            </Row> */}

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingVariations;